export class TimeUnit {
    constructor(scale) {
        this.scale = scale;
    }
    toNanos(duration) {
        return this.scale * duration / TimeUnit.NANOSECONDS.scale;
    }
    toMicros(duration) {
        return this.scale * duration / TimeUnit.MICROSECONDS.scale;
    }
    toMillis(duration) {
        return this.scale * duration / TimeUnit.MILLISECONDS.scale;
    }
    toSeconds(duration) {
        return this.scale * duration / TimeUnit.SECONDS.scale;
    }
    toMinutes(duration) {
        return this.scale * duration / TimeUnit.MINUTES.scale;
    }
    toHours(duration) {
        return this.scale * duration / TimeUnit.HOURS.scale;
    }
    toDays(duration) {
        return this.scale * duration / TimeUnit.DAYS.scale;
    }
}
TimeUnit.NANOSECONDS = new TimeUnit(1);
TimeUnit.MICROSECONDS = new TimeUnit(TimeUnit.NANOSECONDS.scale * 1000);
TimeUnit.MILLISECONDS = new TimeUnit(TimeUnit.MICROSECONDS.scale * 1000);
TimeUnit.SECONDS = new TimeUnit(TimeUnit.MILLISECONDS.scale * 1000);
TimeUnit.MINUTES = new TimeUnit(TimeUnit.SECONDS.scale * 60);
TimeUnit.HOURS = new TimeUnit(TimeUnit.MINUTES.scale * 60);
TimeUnit.DAYS = new TimeUnit(TimeUnit.HOURS.scale * 24);
//# sourceMappingURL=time-unit.js.map